import { render } from "./AgilesActivites.vue?vue&type=template&id=2f08f79c&scoped=true"
import script from "./AgilesActivites.vue?vue&type=script&lang=js"
export * from "./AgilesActivites.vue?vue&type=script&lang=js"

import "./AgilesActivites.vue?vue&type=style&index=0&id=2f08f79c&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f08f79c"]])

export default __exports__